import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SortingRule } from "react-table";
import { Parameter } from '../../models/Parameter';
import { GetStatusWithPipeDTO } from '../../models/Status/GetStatusWithPipeDTO';
import { StatusService } from '../../services/StatusService';

import Routes from "../../helpers/Routes";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";

import { Col, Row } from 'reactstrap';
import ButtonComponent from '../../components/ButtonComponent';
import Layout from '../../components/Layout/Layout';
import { SelectItemsProps } from "../../components/Select2Component";
import SelectComponent from "../../components/SelectComponent";
import TableComponent, { OperationsCell } from "../../components/TableComponent";



export default function StatusIndex() {
    const statusService = new StatusService();
    const [status, setStatus] = useState<GetStatusWithPipeDTO[]>([]);
   
    const [loading, setLoading] = useState(false);

    const intl = useIntl();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const pageSizes: number[] = [5, 15, 30];
    const [pageCount, setPageCount] = useState(1);
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(
        Utilities.LoadPageSizeFromURLQuery(pageSizes)
    );
    const [currentPage, setCurrentPage] = useState<number>();
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<
        SortingRule<object>[] | null
      >(null);
    const [goToPage, setGoToPage] = useState<number>();
    const [initialSortBy] = useState<SortingRule<object>[]>(
        Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder")
    );

    const [reloadSearch, setReloadSearch] = useState<boolean>(false);

    const [pipes, setPipes] = useState<SelectItemsProps[]>([]);

    //Search Parameters
    const [namePipe, setNamePipe] = useState<string>(
      Utilities.LoadParameterFromURLQuery("namePipe", "string", "")
  );


  //obter tipo de processo
    const getAllPipes = async () => {

      var response = await statusService.GetAllPipes();

      if (response.success === false || response.obj === null) {
        Toast.Show("error", response.message);
        return [];
      }

      const list: SelectItemsProps[] = [];
      
      response.obj.forEach((element) => {
        var item: SelectItemsProps = {
          value: element.name,
          label: element.name,
        };
        list.push(item);
      });

      setPipes(list);
    };

    useEffect(() => {
      getAllPipes();
    }, []);

  const onNewTaskClick = () => {
    navigate(Routes.status.create);
  };

    const columns = React.useMemo(
        () => [
          {
            Header: "",
            accessor: " ",
            Cell: (props: any) => {
              return (
                <div style={{ display: "flex" }}>
                  {OperationsCell(props.cell.row.original.id, "status")}
                  {
                    <Tooltip title="Ver detalhes" aria-label="Ver detalhes" enterNextDelay={500} enterDelay={500}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          alignContent: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                          height: 30,
                        }}
                      >
                      </div>
                    </Tooltip>
                  }
                </div>
              );
            },
            width: 1,
          },
          {     
            Header: <FormattedMessage id="Screens.User.Info.Status" />,
            accessor: "name",
            width: 70,
          },
          {     
            Header: <FormattedMessage id="Screens.Status.Search.Pipe" />,
            accessor: "namePipe",
            width: 70,
          },
          {     
            Header: <FormattedMessage id="Screens.User.Info.StatusEnumValue" />,
            accessor: "statusEnumValue",
            width: 70,
          },
          {     
            Header: <FormattedMessage id="Screens.User.Info.FrontendName" />,
            accessor: "frontendName",
            width: 70,
          },
          {     
            Header: <FormattedMessage id="Screens.User.Info.FrontendOrder" />,
            accessor: "frontendOrder",
            width: 70,
          },
          {     
            Header: <FormattedMessage id="Screens.User.Info.Color" />,
            accessor: "color",
            width: 70,
          },
          {     
            Header: <FormattedMessage id="Screens.User.Info.Active" />,
            accessor: "active",
            width: 70,
            Cell: ({ value }: { value: boolean | number }) => {
              if (value === 1) return <span>true</span>;
              if (value === 2) return <span>false</span>;
              return <span>{String(value)}</span>;
            }
          }
        ],
      []
    );


    //Dados da tabela
      const fetchData = async (
        page: number,
        pageSize: number,
        sortBy: SortingRule<object>[] | null
      ) => {
    
        //Atualizamos na history do browser a current page e pageSize
        var searchUrl: string = [
          `?page=${page}&pageSize=${pageSize}`,
          ...[
            ["namePipe", "string", namePipe]
          ].map(([key, type, value]) => value ? `&${key}=${value}` : '')
        ].join('');
    
        // Ordenação
        if (sortBy != null && sortBy.length > 0) {
          searchUrl += `${Utilities.AddParamToQueryIfValue(
            "sortField",
            "string",
            sortBy[0].id
          )}${Utilities.AddParamToQueryIfValue(
            "sortOrder",
            "string",
            sortBy[0].desc === true ? "DESC" : "ASC"
          )}`;
        }
    
    //Se antes não existirem parâmetros de pesquisa, significa que o user veio para aqui de uma rota, então para não ficar com duas rotas duplicadas, fazemos replace à rota
    if (searchParams.toString() === "") {
        navigate(`/Status${searchUrl}`, { replace: true });
      } else {
        //Se já existirem parâmetros de pesquisa, não fazemos replace mas push
        navigate(`/Status${searchUrl}`);
      }
  
      setLoading(true);
  
      var response = await statusService.GetAllStatusPaginated(
        mountSearchParameters(),
        Utilities.MountSortParameters(sortBy),
        page,
        pageSize
      );
  
      if (response.success !== true) {
        setStatus([]);
        setCurrentPage(0);
        setPageCount(0);
        setLoading(false);
        setCurrentPageSize(0);
        setCurrentSorting(null);
        Toast.Show("error", response.message);
        return;
      }
      
      setStatus(response.items);
      setCurrentPage(page);
      setPageCount(response.totalPages);
      setCurrentPageSize(pageSize);
      setCurrentSorting(sortBy);
      setLoading(false);
      setGoToPage(0);

      //Se a pesquisa tiver retornado múltiplas páginas e a página atual for superior ao nº de páginas que chegaram mandamos o user para a página 1
    if (response.totalPages > 0 && page > response.totalPages) {
        setGoToPage(1);
      }
    };

    const mountSearchParameters = (): Parameter[] => {
      var parameters: Parameter[] = [];

      parameters.push(new Parameter("namePipe", namePipe));
  
      return parameters;
    };

    const onEnter = () => {
      fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
    };

    const onButtonClick = async () => {
      setCurrentPage(1);
      setGoToPage(1);
      fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
    };

    const onRemoveFiltersClick = async () => {
      setCurrentPage(1);
      setGoToPage(1);
      setNamePipe("");
      setReloadSearch(true);
    };

    useEffect(() => {
        if (reloadSearch === true) {
          fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
          setReloadSearch(false);
        }
        return () => { };
      }, [reloadSearch]);

    return(
        <Layout>
            <div className='pageContainer'>
                <div className='pageHeader'>
                    <span className="pageTitle">
                        <FormattedMessage id="Navbar.Tab.Status" />
                    </span>
                </div>
                <ButtonComponent
                    text={intl.formatMessage({ id: "Screens.Status.Button.CreateStatus" })}
                    onClick={() => onNewTaskClick()} />
            </div>
            <div className="pageBody">
            <Row>
              <Col>
                <Row>
                  <SelectComponent
                    xl={7}
                    lg={7}
                    md={8}
                    sm={8}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={intl.formatMessage({ id: "Screens.Status.Search.Pipe" })}
                    selectedItemValue={namePipe}
                    items={pipes}
                    onChange={(t: string) => {
                    setNamePipe(t);
                    }}
                  />
                </Row> 
                <Row>
                    <Col
                        xl={2}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                        style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}
                    >
                        <ButtonComponent
                          text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                          onClick={onButtonClick}
                          style={{ minWidth: "100px" }}
                        />
                        <ButtonComponent
                          text={intl.formatMessage({ id: "Common.Buttons.RemoveFilters" })}
                          onClick={onRemoveFiltersClick}
                          style={{ minWidth: "113px" }}
                        />
                    </Col>
                  </Row>
                </Col>
              </Row>
                <Row style={{ marginTop: "2rem" }}>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pageComponent">
                      <TableComponent
                          goToPage={goToPage}
                          loading={loading}
                          pageCount={pageCount}
                          columns={columns}
                          manualPagination={true}
                          fetchData={fetchData}
                          pageSizes={pageSizes}
                          initialPage={page}
                          initialPageSize={pageSize}
                          initialSortBy={initialSortBy}
                          data={status}
                          dontOrderFirstCollumn={true}
                      />
                  </div>
                </Col>
              </Row>
            </div>
        </Layout>
    );
}